<template>
  <div class="mt-2 sm:mt-6 px-0 py-5 flex flex-col items-center justify-center relative">
    <!-- <spinner :busy="loading" color="#000" class="mt-12"></spinner> -->

    <!-- <div class="flex space-x-5">
      <button @click="test(0, 0, 0)" class="mt-4 mb-4">0.0</button>
      <button @click="test(0, 3, 4)" class="mt-4 mb-4">3.4</button>
      <button @click="test(0, 5, 5)" class="mt-4 mb-4">5.5</button>
      <button @click="test(0, 5, 7)" class="mt-4 mb-4">5.7</button>
      <button @click="test(1, 0, 0)" class="mt-4 mb-4">10</button>
    </div> -->

    <div class="h-fit flex items-center justify-center space-x-0">
      <vue-apex-charts class="w-full" type="pie" :options="options" :series="series"
        :animations="animations"></vue-apex-charts>
    </div>
  </div>
</template>

<script>
import Spinner from '@/Shared/Spinner';
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'LiveResultsPieChart',

  metaInfo() {
    return {
      title: `Live Results`,
    };
  },

  components: {
    Spinner,
    VueApexCharts,
  },

  props: ['session', 'translations'],

  data() {
    return {
      loading: false,
      options: {
        labels: [],
        colors: ['#53c9ff', '#ffc800', '#ed2805', '#70bf41', '#CCF800'],
        legend: {
          position: 'bottom',
        },
      },
      series: [],
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      },
      refreshIntervalId: null,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.participant.answered',
      (e) => {
        this.load();
      }
    );

    this.load();

    this.refreshIntervalId = window.setInterval(() => {
      this.load();
    }, 10000);
  },

  destroyed() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  },

  methods: {
    load() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      window.axios
        .post(
          this.route('live-results.answers', {
            id: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          this.convert(response.data.answers || {});
          this.loading = false;
        })
        .catch((error) => {
          console.warn('live-results.pie.load failed', error?.response?.status, error?.message);
          this.loading = false;
        });
    },

    convert(answers) {
      let i = 0;
      Object.keys(answers).forEach(key => {
        const value = answers[key];

        // this.options.labels[i] = key;
        // this.series[i] = value;

        this.$set(this.options.labels, i, key);
        this.$set(this.series, i, value);

        i++;
      });
    },


  },
};
</script>
